module.exports = __webpack_public_path__ + "static/blackSwatch-18e1e4c8eec52316edb5ce67f9caccd1.svg";